import React from 'react';
import { Phone, CheckCircle2, Star, Shield, ThumbsUp, Zap } from 'lucide-react';
import { Button } from './Button';
export function Hero() {
  return <div className="relative w-full bg-dark" data-id="element-121">
      {/* Full-bleed background image sitting BEHIND the hero text */}
      <div className="absolute inset-0 z-0" data-id="element-122">
        <img src="https://images.unsplash.com/photo-1504328345606-18bbc8c9d7d1?q=80&w=2000&auto=format&fit=crop" alt="Dark sleek plumbing pipes" className="w-full h-full object-cover" data-id="element-123" />
        {/* Light scrim so the photo stays clearly visible while text remains legible */}
        <div className="absolute inset-0 bg-gradient-to-r from-dark/90 via-dark/70 to-dark/40" data-id="element-124" />
        <div className="absolute inset-0 bg-gradient-to-b from-dark/40 via-transparent to-dark" data-id="element-125" />
      </div>

      <div className="relative z-10 container mx-auto px-4 pt-24 pb-20 md:pt-32 md:pb-28 flex flex-col items-start text-left" data-id="element-126">
        <div className="inline-flex items-center justify-center px-4 py-2 bg-accent/10 backdrop-blur-sm rounded-full mb-6 border border-accent/30 w-max shadow-[0_0_15px_rgba(57,255,20,0.2)]" data-id="element-127">
          <span className="text-accent font-bold tracking-widest uppercase text-sm" data-id="element-128">
            ROC #364179 | Licensed, Bonded, Insured
          </span>
        </div>

        <h1 className="font-display text-4xl md:text-7xl lg:text-8xl text-white uppercase tracking-wide mb-6 leading-[1.1] max-w-3xl drop-shadow-lg" data-id="element-129">
          Out of this World <span className="text-accent" data-id="element-130">Plumbing</span>
        </h1>

        <p className="text-lg md:text-xl text-slate-200 max-w-xl mb-10 font-medium drop-shadow" data-id="element-131">
          24/7 Emergency Plumbing across the Phoenix Valley. Fast response for
          water leaks, sewer backups, and pipe emergencies.
        </p>

        <div className="flex flex-col sm:flex-row items-center gap-4 w-full sm:w-auto mb-8" data-id="element-132">
          <Button className="w-full sm:w-auto h-14 px-8 bg-accent hover:bg-accent-light text-dark font-bold uppercase tracking-wider text-lg rounded-md shadow-[0_0_20px_rgba(57,255,20,0.4)]" data-id="element-133">
            Book Service
          </Button>
          <Button variant="outline" className="w-full sm:w-auto h-14 px-8 border-2 border-white text-white hover:bg-white/10 font-bold uppercase tracking-wider text-lg rounded-md bg-transparent" data-id="element-134">
            <Phone className="mr-2 h-5 w-5" data-id="element-135" />
            (602) 782-0397
          </Button>
        </div>

        <div className="flex items-center gap-2 text-sm md:text-base text-slate-300 font-medium" data-id="element-136">
          <span data-id="element-137">Arizona Native</span>
          <span className="text-accent" data-id="element-138">•</span>
          <span data-id="element-139">Fully licensed</span>
          <span className="text-accent" data-id="element-140">•</span>
          <span data-id="element-141">Fast Response</span>
        </div>
      </div>

      <div className="relative z-10 w-full bg-dark border-y border-accent/20 py-6" data-id="element-142">
        <div className="container mx-auto px-4" data-id="element-143">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 text-center" data-id="element-144">
            <div className="flex flex-col items-center gap-2" data-id="element-145">
              <CheckCircle2 className="h-6 w-6 text-accent" data-id="element-146" />
              <span className="text-sm font-bold text-slate-300 uppercase tracking-wider" data-id="element-147">
                Commercial & Residential
              </span>
            </div>
            <div className="flex flex-col items-center gap-2" data-id="element-148">
              <Star className="h-6 w-6 text-accent-light" data-id="element-149" />
              <span className="text-sm font-bold text-slate-300 uppercase tracking-wider" data-id="element-150">
                5-Star Rated
              </span>
            </div>
            <div className="flex flex-col items-center gap-2" data-id="element-151">
              <Shield className="h-6 w-6 text-accent" data-id="element-152" />
              <span className="text-sm font-bold text-slate-300 uppercase tracking-wider" data-id="element-153">
                Licensed & Insured
              </span>
            </div>
            <div className="flex flex-col items-center gap-2" data-id="element-154">
              <ThumbsUp className="h-6 w-6 text-accent-light" data-id="element-155" />
              <span className="text-sm font-bold text-slate-300 uppercase tracking-wider" data-id="element-156">
                Free Estimates
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>;
}